import React from 'react';

// Formulár na pridávanie/editovanie záznamov pre Evidenciu Práce
const EvidenciaPraceForm = ({
  newEntry,
  setNewEntry,
  services,
  handleAddEntry,
  companies,
  handleServiceChange
}) => {
  return (
    <div className="entry-form">
      <h2>Nový záznam</h2>
      <div className="form-grid">
        <div className="form-group">
          <label>Firma *</label>
          <input
            type="text"
            list="companies-list"
            value={newEntry.companyName}
            onChange={(e) => setNewEntry({ ...newEntry, companyName: e.target.value })}
            placeholder="Názov firmy"
          />
          <datalist id="companies-list">
            {companies.map(company => (
              <option key={company} value={company} />
            ))}
          </datalist>
        </div>
        <div className="form-group">
          <label>Dátum *</label>
          <input
            type="date"
            value={newEntry.date}
            onChange={(e) => setNewEntry({ ...newEntry, date: e.target.value })}
          />
        </div>
        <div className="form-group">
          <label>Služba</label>
          <select
            value={newEntry.service}
            onChange={(e) => handleServiceChange(e.target.value)}
          >
            <option value="">-- Vyberte službu --</option>
            {Object.keys(services).map(service => (
              <option key={service} value={service}>{service}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Popis práce *</label>
          <input
            type="text"
            value={newEntry.description}
            onChange={(e) => setNewEntry({ ...newEntry, description: e.target.value })}
            placeholder="Napr. Účtovanie dokladov za júl"
          />
        </div>
        <div className="form-group">
          <label>Množstvo {newEntry.service && newEntry.service.toLowerCase().includes('hod') ? '(hodiny)' : '(počet kusov)'}</label>
          <input
            type="number"
            step="0.01"
            value={newEntry.quantity}
            onChange={(e) => setNewEntry({ ...newEntry, quantity: parseFloat(e.target.value) || 0 })}
            placeholder={newEntry.service && newEntry.service.toLowerCase().includes('hod') ? 'napr. 2.5' : 'napr. 1'}
          />
        </div>
        <div className="form-group">
          <label>Jednotková cena (€)</label>
          <input
            type="number"
            step="0.01"
            value={newEntry.unitPrice}
            onChange={(e) => setNewEntry({ ...newEntry, unitPrice: parseFloat(e.target.value) || 0 })}
          />
        </div>
        <div className="form-group">
          <label>Skutočná cena v faktúre (€)</label>
          <input
            type="number"
            step="0.01"
            value={newEntry.actualInvoicePrice}
            onChange={(e) => setNewEntry({ ...newEntry, actualInvoicePrice: parseFloat(e.target.value) || 0 })}
            placeholder="Čo naozaj fakturujete"
          />
        </div>
        <div className="form-group full-width">
          <label>Poznámka</label>
          <input
            type="text"
            value={newEntry.note}
            onChange={(e) => setNewEntry({ ...newEntry, note: e.target.value })}
            placeholder="Nepovinná poznámka"
          />
        </div>
      </div>
      <button onClick={handleAddEntry} className="btn-add">Pridať záznam</button>
    </div>
  );
};

export default EvidenciaPraceForm;
